import React from 'react';
import HorizontalTimeline from 'react-horizontal-timeline';
import PhotoGallery from '../thirdParty/PhotoGallery';

export default class App extends React.Component {
  state = { value: this.props.number, previous: 0 };

  render() {
    const VALUES = this.props.date;
    const Content = this.props.content;
    const title = this.props.title;
    return (
      <div>
        {/* Bounding box for the Timeline */}
        <div
          style={{
            width: '90%',
            height: '100px',
            margin: '0 auto',
            fontSize: '14px',
          }}
        >
          <HorizontalTimeline
            isTouchEnabled='true'
            isOpenEnding='false'
            isOpenBeginning='false'
            index={this.state.value}
            indexClick={(index) => {
              this.setState({
                value: index,
                previous: this.state.value,
              });
            }}
            values={VALUES}
            styles={{
              background: '#F5F5F5',
              foreground: '#E6B073',
            }}
          />
        </div>
        <div className='text-center'>
          {/* any arbitrary component can go here */}
          <h3 className='text-secondary chinese'>{title[this.state.value]}</h3>
          <div>
            <PhotoGallery images={Content[this.state.value]} />
            {/* {Content[this.state.value]} */}
          </div>
        </div>
      </div>
    );
  }
}
